import React from "react";
import { Select as AntdSelect } from "antd";

const { Option } = AntdSelect;

const Select = ({
	defaultValue,
	dispatch,
	name,
	questionId,
	row,
	lookup,
	placeholder,
	isNew,
	dataType,
	options,
	...otherProps
}) => {
	const { valueField, showCode, multiple, mode } = options || {
		valueField: null,
		showCode: false,
		multiple: false,
	};

	const [answerAdded, answerEdited] = dispatch;

	const onChange = (value, options) => {
		let conditionalValue;
		//if multiple options came, and the mode is not multiple - this happens for tag-based Select that is forcibly multi select by Antd
		if (options?.length > 0 && !multiple) {
			conditionalValue = options.length === 1 ? value[0] : value.join("");
		} else {
			conditionalValue = value;
		}
		let data = {
			questionId: questionId,
			value: conditionalValue,
			id: name,
			row: row,
		};

		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};

	return (
		<AntdSelect
			allowClear
			showSearch
			mode={mode}
			style={{ width: "100%" }}
			onChange={onChange}
			value={defaultValue ? defaultValue : undefined}
			placeholder={placeholder || "Search by description"}
			filterOption={(input, option) =>
				option?.children
					?.toString()
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
			}
			{...otherProps}
			tagRender={({ value, label }) => {
				return label !== value ? label[0] : value;
			}}
		>
			{lookup.map((p) => (
				<Option
					key={p.code}
					value={valueField ? p[valueField] : p.code}
					className="antd-select-option"
				>
					{p.description}
					{showCode && p.code && ` (${p.code})`}
				</Option>
			))}
		</AntdSelect>
	);
};

export default Select;
